<template>
  <div id="relListPed">
    <section class="mt-4 card">
      <b-card-header
        :header="statusSelecionado.descricao"
        header-text-variant="white"
        :style="cor"
      />
      <b-card class="cardBody">
        <b-card-text class="table">
          <b-table bordered striped :items="pedidos" :fields="fieldsPedidos" v-if="pedidos && pedidos.length > 0">
            <template slot="urlImagemCanal" slot-scope="row">
              <img :src="row.item.canal.url">
            </template>
            <template slot="mobile" slot-scope="row">
              <div class="form-row mb-1">
                <div class="col-md-8"><strong>{{toCapitalize(row.item.fantasia)}}</strong></div>
                <div class="col-md-4 txtRight"><strong>Cód.: {{row.item.codCliente}}</strong></div>
              </div>
              <div class="form-row mb-1">
                <div class="col-md-8">{{toCapitalize(row.item.razaoSocial)}}</div>
                <div class="col-md-4">Emissão: {{row.item.emissao}}</div>
              </div>
              <div class="form-row mb-1">
                <div class="col-md-8" v-if="row.item.numeroOrcamento">Nº Orç.: {{row.item.numeroOrcamento}}</div>
                <div class="col-md-8" v-else>Nº Orç.: -</div>
                <div class="col-md-4 txtRight" v-if="row.item.numeroPedido">Nº Ped.: {{row.item.numeroPedido}}</div>
                <div class="col-md-4 txtRight" v-else>Nº Ped.: -</div>
              </div>
              <div class="form-row mb-1">
                <div class="col-md-8">Status {{row.item.status.descricao}}</div>
                <div class="col-md-4 txtRight" v-if="row.item.numeroPedidoCompra">Ped. Compra: {{row.item.numeroPedidoCompra}}</div>
                <div class="col-md-4 txtRight" v-else>Ped. Compra: -</div>
              </div>
              <div class="form-row mb-1">
                <div class="col-md-8 relPedImgMob"><img :src="row.item.canal.url"></div>
                <div class="col-md-4 txtRight">Total: {{formatterValue(row.item.totalPedido)}}</div>
              </div>
            </template>
          </b-table>
          <span v-else>
            Não há itens para este filtro
          </span>
        </b-card-text>
      </b-card>
    </section>
  </div>
</template>
<script>
  import tablePedidos from '@/services/tablePedidos'
  export default {
    props: {
      pObjPedido: {},
      pObjStatus: {}
    },
    data () {
      return {
        cor: '',
        blockUI: {
          message: '',
          blockUiVisibility: false
        },
        tipoPedido: [],
        statusSelecionado: {},
        pedidos: [],
        fieldsPedidos: [
          {
            key: 'urlImagemCanal',
            label: 'Origem',
            sortable: false,
            class: 'relPedImg'
          },
          {
            key: 'fantasia',
            label: 'Fantasia',
            sortable: true,
            class: 'relPedFant txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'razaoSocial',
            label: 'Razão Social',
            sortable: true,
            class: 'relPedRaz txtLeft',
            formatter: this.toCapitalize
          },
          {
            key: 'numeroOrcamento',
            label: 'Nº Orç',
            sortable: true,
            class: 'relPedNOrc'
          },
          {
            key: 'numeroPedido',
            label: 'Nº Pedido',
            sortable: true,
            class: 'relPedNPed'
          },
          {
            key: 'emissao',
            label: 'Emissão',
            sortable: true,
            class: 'relPedEmi'
          },
          {
            key: 'numeroPedidoCompra',
            label: 'Pedido Compra',
            sortable: true,
            class: 'relPedPCom'
          },
          {
            key: 'totalPedido',
            label: 'Total R$',
            sortable: true,
            class: 'relPedTot txtRight',
            formatter: this.formatterValue
          },
          {
            label: '',
            key: 'mobile',
            class: 'relPedMobile txtLeft'
          }
        ]
      }
    },
    created () {
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
    },
    watch: {
      pObjPedido: function (newVal, oldVal) { // watch it
        // console.log(JSON.stringify(newVal))
        this.statusSelecionado = this.pObjStatus
        this.pedidos = newVal
      }
    },
    methods: {
      formatterValue: function (valor) {
        let val = (valor / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      showMessage: function (message, title, variantColor) {
        this.message = message
        this.titleMsg = title
        this.variant = variantColor
        this.$bvToast.show('my-toast')
      },
      listandoPedidos: function (objectPost) {
        this.msgBlockUi = 'Listando pedidos favor aguarde...'
        this.blockUiVisibility = true
        tablePedidos.listarPedidos(objectPost).then(response => {
          this.status = this.montaPedidos(response.data.pedidos)
        }).catch(error => {
          console.log(error)
          alert('Aconteceu alguma coisa!' + error)
        }).finally(() => {
          this.blockUiVisibility = false
        })
      },
      montaPedidos: function (pedidos) {
        let statusPedidos = []
        let pedidosSemStatus = []
        for (var i = 0; i < pedidos.length; i++) {
          let pedido = pedidos[i]
          if (i === 0) {
            statusPedidos.push(pedido.status)
          } else {
            let statusExistentes = statusPedidos.filter(status => status.codigo === pedido.status.codigo)
            if (statusExistentes.length <= 0) {
              statusPedidos.push(pedido.status)
            }
          }
          delete pedido.status
          pedidosSemStatus.push(pedido)
        }
        statusPedidos = statusPedidos.sort(function (a, b) {
          return a.ordem - b.ordem
        })
        for (var indice = 0; indice < statusPedidos.length; indice++) {
          let status = statusPedidos[indice]
          let pedidosDoStatus = pedidosSemStatus.filter(pedido => pedido.codStatus === status.codigo)
          statusPedidos[indice].pedidos = pedidosDoStatus
        }
        return statusPedidos
      },
      listarPedidos: function (objectPost) {
        tablePedidos.listarPedidos(objectPost).then(response => {
          this.status = response.data.pedidos
        })
      },
      toCapitalize: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      }
    }
  }
</script>
<style scoped>
  .table {
    overflow-y: auto;
    max-height: 350px;
    font-size: 14px;
  }
  .relPedImg img {
    max-width: 100%;
    max-height: 20px;
  }
  .relPedImgMob img {
    max-width: 100%;
    max-height: 17px;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/relatorioPedidosVue.vue